import { Link } from "react-router-dom";

export default function FeaturesStrip() {
  const features = [
    {
      icon: "ri-shield-check-line",
      title: "安全私密",
      desc: "严格年龄验证，保护用户隐私",
    },
    {
      icon: "ri-smartphone-line",
      title: "多端适配",
      desc: "电脑手机平板，随时随地阅读",
    },
    {
      icon: "ri-flashlight-line",
      title: "极速加载",
      desc: "CDN加速，流畅翻页不卡顿",
    },
    {
      icon: "ri-bookmark-line",
      title: "书签收藏",
      desc: "收藏最爱漫画，追更不迷路",
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-10 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div key={i} className="flex flex-col items-center text-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-full">
                <i className={`${f.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-sm font-semibold text-white">{f.title}</h3>
              <p className="text-xs text-white/70">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}